import * as React from 'react';
import { IconButton, Tooltip } from '@chakra-ui/react';

export const tiptapButtonStyle = {
   size: 'sm',
   mx: 0.5,
   bgColor: 'gray.50',
   color: 'gray.500',
   outline: 'none',
   border: 'none',
   _hover: {
      bgColor: 'gray.100',
   },
   _focus: {
      bgColor: 'gray.100',
   },
   _active: {
      bgColor: 'gray.200',
   },
};

interface TiptapButtonProps {
   onClick: () => void;
   isActive?: boolean;
   isDisabled?: boolean;
   icon: React.ReactElement;
   title: string;
   shortcut?: string;
   overrideShortcut?: string;
   iconButtonStyle?: object;
}

export const TiptapButton = (props: TiptapButtonProps) => {
   // Label logic originally from prosemirror-example-setup/menu/menu.js
   const hasShortcut: boolean = Boolean(props.shortcut || props.overrideShortcut);
   const modKey = navigator.userAgent.indexOf('Mac') > 0 ? '⌘' : 'ctrl+';
   const shortcutText = props.overrideShortcut ?? `${modKey}${props.shortcut}`;
   const label = hasShortcut ? `${props.title} (${shortcutText})` : props.title;

   const { onClick, isActive, isDisabled, icon, title, iconButtonStyle } = props;
   const iconButtonProps = { onClick, isActive, isDisabled, icon, 'aria-label': title };

   if (isDisabled) {
      return <IconButton {...tiptapButtonStyle} {...iconButtonStyle} {...iconButtonProps} />;
   } else {
      return (
         <Tooltip placement="top-start" label={label}>
            <IconButton {...tiptapButtonStyle} {...iconButtonStyle} {...iconButtonProps} />
         </Tooltip>
      );
   }
};
